interface FooterProps {
    children?: React.ReactNode
}

function Footer({ children }: FooterProps) {
    return (
        <footer className="footer">
            <p>
                This application is for demonstration purposes only. For more information go to &nbsp;
                <a href="https://developers.maya.ph/">https://developers.maya.ph/</a>
            </p>
           { children }
        </footer>
    )
}

export default Footer